import React from 'react'
import SbEditable from 'storyblok-react'
import cx from 'classnames'

import Components from './../Components'

import styles from './styles.module.scss'

const Row = (props) => {

	const rowClasses = cx({
		'row': true,
		[styles['row__row']]: true,
		[styles['row__row--centered']]: props.blok.center_content_vertical
	})

	return (
		<SbEditable content={props.blok}>
			<section className={styles['row']} style={{ backgroundColor: props.blok.background_color, padding: props.blok.disable_vertical_padding && 0 }}>
				{props.blok.vertical_title && <span className={'section-title'}>{props.blok.title}</span>}
				<div className='container'>
					<div className={rowClasses}>
						{props.blok.columns.map((blok, i) => {
							return (
								<div key={i} className={`col ${styles['row__col']}`}>
									{React.createElement(Components(blok.component), {
										key: blok._uid,
										blok: blok
									})}
								</div>
							)
						})}
					</div>
				</div>
			</section>
		</SbEditable>
	)
}

export default Row
